import {
    Avatar,
    Button,
    Card,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import LoadingAnimation from "../../../Components/LottieAnimation/LoadingAnimation";
import { PrimaryButton } from "../../../Layouts/ButtonsControlled";
import { FormHeading } from "../../../Layouts/Heading";
import {
    AdderRateInstaller,
    getAllInstaller,
    reset,
} from "../../../Redux/InstallerSlice/InstallerSlice";
import uploadImage from "../../../Assets/images/uploadImage.png";
import {
    adderReset,
    GetAllAdders,
} from "../../../Redux/AddersSlice/AddersSlice";
import { Add, Delete } from "@mui/icons-material";

const AddersRate = ({nextForm}) => {
    const { isLodaing, isSuccess, isError, errors } = useSelector(
        (state) => state.installer
    );

    const { installer } = useSelector((state) => state.installer);
    const installersVal = installer?.data || [];

    const { adders } = useSelector((state) => state.adders);

    const AllAdders = adders?.data || [];

    const dispatch = useDispatch();


    // ========================
    // Create Add More Adders Form
    // ========================
    const AdderInputs = {
        user_id: 0,
        adder_id: "",
        price: 0,
        unit: "",
    };

    const [AddersForm, setAddersForm] = useState([AdderInputs]);

    const handleAddAdder = () => {
        console.log(AddersForm);
        let data = AddersForm;
        data = [...AddersForm, AdderInputs];
        setAddersForm(data);
    };

    const handleChangeFormInputs = (e, adder, index) => {
        let data = [...AddersForm];
        data[index][e.target.name] = e.target.value;
        setAddersForm(data);
        console.log(AddersForm);
    };
    // ========================
    // End Add More Adder Form
    // ========================

    const formik = useFormik({
        initialValues: {
            user_id: 0,
            adder_id: "",
            price: 0,
            unit: "",
        },

        onSubmit: async (values) => {
            const formData = new FormData();

            AddersForm.map((adder, index) => {
                formData.append(`data[${index}][user_id]`, adder.user_id);
                formData.append(`data[${index}][adder_id]`, adder.adder_id);
                formData.append(`data[${index}][price]`, adder.price);
                formData.append(`data[${index}][unit]`, adder.unit);
            });
            console.log(formData);
            await dispatch(AdderRateInstaller(formData));
            await dispatch(reset())
        },
    });

    const GetAllAddersAction = async () => {
        await dispatch(GetAllAdders({return_all: 1}));
        await dispatch(adderReset());
    };
    const GetallInstallersAction = async () => {
        await dispatch(getAllInstaller());
        await dispatch(reset());
    };
    useEffect(() => {
        GetallInstallersAction();
        GetAllAddersAction();
    }, [dispatch]);

    const handelDeleteAdderRowForm = (e, index) => {
        let data = [...AddersForm];
        data.splice(index, 1);
        setAddersForm(data);
    };

    useEffect(()=> {
        if (isSuccess && AddersForm[0].user_id) {
            toast.success("successfully registered")
            nextForm();
        };
    }, [isSuccess, AddersForm, nextForm])

    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    toast.error(errors[key].msg);
                });
            }
            const resetMethod = async () => {
                await dispatch(reset());
            };
            resetMethod();
        }
    }, [dispatch, errors, isError]);

    return (
        <>
            {isLodaing && <LoadingAnimation />}
            {!isLodaing && (
                <FormContainer>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3} mb={3} mt={3}>
                            <Grid item mb={1} xs={12} md={3}>
                                <Button
                                    fullWidth
                                    style={{ float: "right" }}
                                    variant="contained"
                                    color="success"
                                    onClick={(e) => handleAddAdder(e)}
                                >
                                    <Add />
                                    Add Adder
                                </Button>
                            </Grid>
                        </Grid>
                        {AddersForm?.map((adder, index) => (
                            <Card
                                key={index}
                                style={{ padding: "10px" }}
                                mt={3}
                            >
                                <Grid container columns={12} spacing={3}>
                                    <Grid item mb={1} xs={12} md={3}>
                                        <FormControl fullWidth required={true}>
                                            <InputLabel id="demo-simple-select-label">
                                                Installer
                                            </InputLabel>
                                            <Select
                                                id="user_id"
                                                name="user_id"
                                                label="Installer"
                                                required
                                                value={adder.user_id}
                                                onChange={(e) =>
                                                    handleChangeFormInputs(
                                                        e,
                                                        adder,
                                                        index
                                                    )
                                                }
                                            >
                                                {installersVal?.map((key) => (
                                                    <MenuItem
                                                        key={key.id}
                                                        value={key.id}
                                                    >
                                                        {key.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item mb={1} xs={12} md={3}>
                                        <FormControl fullWidth required={true}>
                                            <InputLabel id="demo-simple-select-label">
                                                Adders
                                            </InputLabel>
                                            <Select
                                                id="adder_id"
                                                name="adder_id"
                                                label="Adder"
                                                required
                                                value={adder.adder_id}
                                                onChange={(e) =>
                                                    handleChangeFormInputs(
                                                        e,
                                                        adder,
                                                        index
                                                    )
                                                }
                                            >
                                                {AllAdders?.map((key) => (
                                                    <MenuItem
                                                        key={key.id}
                                                        value={key.id}
                                                    >
                                                        {key.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item mb={1} xs={12} md={2}>
                                        <TextField
                                            fullWidth
                                            id="price"
                                            name="price"
                                            label="Price"
                                            type="number"
                                            value={adder.price}
                                            onChange={(e) =>
                                                handleChangeFormInputs(
                                                    e,
                                                    adder,
                                                    index
                                                )
                                            }
                                        />
                                    </Grid>
                                    <Grid item mb={1} xs={12} md={2}>
                                        <TextField
                                            fullWidth
                                            id="unit"
                                            name="unit"
                                            label="Unit"
                                            value={adder.unit}
                                            onChange={(e) =>
                                                handleChangeFormInputs(
                                                    e,
                                                    adder,
                                                    index
                                                )
                                            }
                                        />
                                    </Grid>
                                    <Grid item mb={1} xs={12} md={2}>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="error"
                                            onClick={(e) =>
                                                handelDeleteAdderRowForm(
                                                    e,
                                                    index
                                                )
                                            }
                                        >
                                            <Delete />
                                            Delete
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Card>
                        ))}
                        <PrimaryButton fullWidth type="submit">
                            {isLodaing ? "loading ... " : "Save"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;
export default AddersRate;
